module.exports = __webpack_public_path__ + "static/RecruitCarrer-0114b3d6d0883ff366b1de4126001e1a.png";